module.exports = __webpack_public_path__ + "e0771825cd1ab7214ea968204d383efe.otf";